import {ClinchEvent} from 'common/src/hooks/useClinchEvent';
import {CLCustomEvent} from './CLLocalStorage.types';

function _get(key: string, defaultValue: string = undefined, silent = true): string {
  let result;

  try {
    result = window.localStorage.getItem(key) || defaultValue;
  } catch (exception) {
    return '';
  }

  if (!silent && !result) throw `key: ${key} was not found in localStorage`;

  return result;
}

function _set(key: string, value: string) {
  try {
    window.localStorage.setItem(key, value);
    document.dispatchEvent(
      new CustomEvent<CLCustomEvent>(ClinchEvent.CLStorage, {detail: {key, value}}),
    );

    return true;
  } catch (exception) {
    /**
     * in case of mobile safari on private browsing the localStorage limitation is set to zero bytes,
     * so this exception would be caught.
     */
    console.warn('could not store key', key, 'in local storage, exception: ', exception);

    return false;
  }
}

const CLLocalStorage = {
  set: _set,
  setStringified: function <T>(key: string, value: T): string {
    const stringified = JSON.stringify(value);
    _set(key, JSON.stringify(value));

    return stringified;
  },
  get: _get,
  getParsed: function <T>(key: string, defaultValue: T = undefined, silent = true): T | undefined {
    const strValue = _get(key, undefined, silent);
    let result: T | undefined;

    try {
      result = strValue ? (JSON.parse(strValue) as T) : defaultValue;
    } catch (exception) {
      result = defaultValue;
    }

    return result;
  },
  clear: function () {
    return window.localStorage.clear();
  },
  remove: function (key: string) {
    window.localStorage.removeItem(key);
    document.dispatchEvent(new CustomEvent<CLCustomEvent>(ClinchEvent.CLStorage, {detail: {key}}));
  },
};

export default CLLocalStorage;
